import { fragmentPrice } from '~/customQueries/productDetails';

export default `
  query productsInRange(
    $search: String = "",
    $filter: ProductAttributeFilterInput,
    $pageSize: Int = 12,
    $currentPage: Int = 1,
    $sort: ProductAttributeSortInput
  ) {
    products(search: $search, filter: $filter, sort: $sort, pageSize: $pageSize, currentPage: $currentPage) {
      items {
        uid
        id
        sku
        name
        url_key
        url_rewrites {
          url
        }
        small_image {
          url
          position
          disabled
          label
        }
        ...Price
      }
    }
  }
  ${fragmentPrice}
`;
